import { useEffect, useMemo } from 'react';
import TableGrouping, { IColumnsGrouping } from '../../components/table-grouping/TableGrouping';
import useMultiLanguage from '../../../hook/useMultiLanguage';
import { CODE_WEEKEND, NUMBER_SHEET_TIMESHEET_SHIFT } from '../constants/timesheetConsts';
import { checkWeekend, checkWeekendOrHoliday } from '../../utils/functionUtils';

const TabTableChamCongThemGio = (props: any) => {
    const { data, dateSearch, listAttribution = [] } = props;
    const { lang } = useMultiLanguage();

    useEffect(() => {
        const dayOfMonth = new Date(dateSearch.nam, dateSearch?.thang, 0).getDate();
        const yellowTds = document.querySelectorAll("td.isWeekendPrint");
        const theadRows = document.querySelectorAll("#content-print thead tr th");

        yellowTds.forEach((td) => {
            const colIndex = (td as HTMLTableCellElement).cellIndex;

            for (let i = theadRows.length - 1; i >= 0; i--) {
                const th1 = theadRows[colIndex + 2] as HTMLTableCellElement | null;
                const th2 = theadRows[colIndex + 2 + dayOfMonth + listAttribution.length] as HTMLTableCellElement | null;
                if (th1 && th2) {
                    th1.classList.add("isWeekendPrint");
                    th2.classList.add("isWeekendPrint");
                    break;
                }
            }
        });
    });

    const columns = ({ dateSearch }: any): IColumnsGrouping[] => {
        const listColumn: IColumnsGrouping[] = [
            {
                name: "STT",
                field: "stt",
                render: (row: any, index: number, stt: number) => <span>{stt}</span>,
            },
            {
                name: "Họ và tên",
                field: "employeeText",
                headerStyle: {
                    minWidth: "150px"
                },
                cellStyle: {
                    textAlign: "left"
                },
            },
            {
                name: "Khoa phòng",
                field: "phongBanText",
                headerStyle: {
                    minWidth: "200px"
                },
                cellStyle: {
                    textAlign: "left"
                },
            },
            {
                name: "Cấp bậc chức vụ",
                field: "chucDanhText",
                headerStyle: {
                    minWidth: "200px"
                },
                cellStyle: {
                    textAlign: "left"
                },
            },
        ];

        const weekdays = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];
        const listDate = [];
        const dayOfMonth = new Date(dateSearch.nam, dateSearch?.thang, 0).getDate();

        for (let i = 1; i <= dayOfMonth; i++) {
            const currentDate = new Date(dateSearch.nam, dateSearch.thang - 1, i);
            const dayOfWeek = weekdays[currentDate.getDay()];
            listDate.push({
                name: String(i),
                field: `ngay${i}`,
                headerStyle: {
                    minWidth: "20px",
                },
                className: checkWeekend(dateSearch.nam, dateSearch.thang, i) ? `isWeekendPrint` : '',
                cellClassName: (row: any, index: number) => {
                    return checkWeekendOrHoliday(row?.[`ngay${i}`]?.defaultCode) ? `isWeekendPrint` : ''
                },
                child: [
                    {
                        name: dayOfWeek,
                        field: `thu${i}`,
                        headerStyle: {
                            minWidth: "20px",
                        },
                        className: checkWeekend(dateSearch.nam, dateSearch.thang, i) ? `isWeekendPrint` : '',
                        cellClassName: (row: any, index: number) => {
                            return checkWeekendOrHoliday(row?.[`ngay${i}`]?.defaultCode) ? `isWeekendPrint` : ''
                        },
                        render: (row: any, index: number) => {
                            return (
                                <span>{row?.[`ngay${i}`]?.soGioLamThem || ''}</span>
                            )
                        }
                    }
                ],
            });
        }

        listColumn.push({
            name: "Ngày trong tháng",
            field: "date",
            headerStyle: {
                minWidth: "40px",
                maxWidth: "40px",
            },
            child: listDate
        });

        const listStatistical: IColumnsGrouping[] = [];
        listAttribution.forEach((attribution: any) => {
            listStatistical.push({
                name: attribution?.name,
                field: attribution?.fieldName,
                headerStyle: {
                    minWidth: "180px"
                },
            })
        });

        listColumn.push({
            name: "Cộng số giờ làm thêm",
            field: "statistical",
            headerStyle: {
                minWidth: "180px"
            },
            child: listStatistical
        });

        return listColumn;
    }

    const memoizedTable = useMemo(
        () => {
            return (
                <TableGrouping
                    className="table-custom table-cham-cong"
                    id="timeSheets"
                    columns={columns({
                        dateSearch
                    })}
                    data={data}
                    prefixDataField="data"
                    prefixTitleField="phongBanText"
                />
            )
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [data]
    );

    return (
        <div>{memoizedTable}</div>
    )
};

export default TabTableChamCongThemGio;